module.exports = __webpack_public_path__ + "media/src/assets/Images/BackIcon-aaa777c006871d8dce61071a741f4a21.svg";